var map = {
	"./logo-alphabet.svg": 1731,
	"./logo-amazon-2.svg": 1732,
	"./logo-amazon.svg": 1302,
	"./logo-azercell.svg": 1563,
	"./logo-bank-of-america.svg": 696,
	"./logo-barclays.svg": 697,
	"./logo-bbc.svg": 1733,
	"./logo-bnp-paribas.svg": 698,
	"./logo-booking.svg": 563,
	"./logo-citibank.svg": 516,
	"./logo-coca-cola.svg": 1734,
	"./logo-deloitte.svg": 1735,
	"./logo-experian.svg": 1736,
	"./logo-facebook.svg": 1737,
	"./logo-g.svg": 1738,
	"./logo-goldman-sachs.svg": 699,
	"./logo-google.svg": 1739,
	"./logo-h.svg": 1740,
	"./logo-henkel.svg": 1741,
	"./logo-hsbc.svg": 1742,
	"./logo-ikea.svg": 1743,
	"./logo-infineon.svg": 1744,
	"./logo-instagram.svg": 1745,
	"./logo-jp-morgan.svg": 700,
	"./logo-jti.svg": 1587,
	"./logo-linkedin.svg": 1746,
	"./logo-meta.svg": 1747,
	"./logo-morgan-stanley.svg": 1748,
	"./logo-netflix.svg": 1749,
	"./logo-oracle.svg": 1303,
	"./logo-paypal.svg": 517,
	"./logo-pwc-new.svg": 1750,
	"./logo-pwc.svg": 1751,
	"./logo-spotify.svg": 1752,
	"./logo-tesla.svg": 518,
	"./logo-visa.svg": 1304,
	"./logo-walmart.svg": 504,
	"./logo-youtube.svg": 1753
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1730;